/**
 * Theme configurations for charts
 */

// Default color palette
export const DEFAULT_COLORS = [
  '#1d5bec', '#66e343', '#fc803c', '#cf28d0', '#5671f1', 
  '#8ceb60', '#f7a845', '#d352db', '#8392f1', '#aaef7a', 
  '#fb903e', '#dc79e4', '#acb0f2', '#c4f29f', '#f8b774', 
  '#e4a1eb', '#d4d5f6', '#dbf7bf', '#fcd6a8', '#eec4f0'
];

// Default light theme
export const LIGHT_THEME = {
  color: DEFAULT_COLORS,
  background: '#ffffff',
  padding: [20, 20, 20, 20],
  brandColor: '#1d5bec',
  series: {
    bar: {
      style: {
        fillOpacity: 0.85,
        stroke: '#ffffff',
        lineWidth: 0.5
      }
    },
    line: {
      style: {
        lineWidth: 2,
        smooth: true
      }
    },
    area: {
      style: {
        fillOpacity: 0.5,
        stroke: '#ffffff',
        lineWidth: 1
      }
    },
    pie: {
      style: {
        stroke: '#ffffff',
        lineWidth: 1
      }
    }
  },
  axes: {
    grid: {
      style: {
        stroke: '#E8E8E8',
        lineWidth: 1
      }
    },
    label: {
      style: {
        fontSize: 12,
        fill: '#6E6E6E'
      }
    },
    title: {
      style: {
        fontSize: 14,
        fill: '#222222',
        fontWeight: 'bold'
      }
    }
  }
};

// Dark theme
export const DARK_THEME = {
  color: DEFAULT_COLORS,
  background: '#1e1e1e',
  padding: [20, 20, 20, 20],
  brandColor: '#1d5bec',
  series: {
    bar: {
      style: {
        fillOpacity: 0.85,
        stroke: '#1e1e1e',
        lineWidth: 0.5
      }
    },
    line: {
      style: {
        lineWidth: 2,
        smooth: true
      }
    },
    area: {
      style: {
        fillOpacity: 0.5,
        stroke: '#1e1e1e',
        lineWidth: 1
      }
    },
    pie: {
      style: {
        stroke: '#1e1e1e',
        lineWidth: 1
      }
    }
  },
  axes: {
    grid: {
      style: {
        stroke: '#333333',
        lineWidth: 1
      }
    },
    label: {
      style: {
        fontSize: 12,
        fill: '#BBBBBB'
      }
    },
    title: {
      style: {
        fontSize: 14,
        fill: '#EEEEEE',
        fontWeight: 'bold'
      }
    }
  }
}; 